import { render, staticRenderFns } from "./MandatesTable.vue?vue&type=template&id=b95b3fc2&scoped=true&"
import script from "./MandatesTable.vue?vue&type=script&lang=js&"
export * from "./MandatesTable.vue?vue&type=script&lang=js&"
import style0 from "./MandatesTable.vue?vue&type=style&index=0&id=b95b3fc2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95b3fc2",
  null
  
)

export default component.exports